import { Box, Flex, Text, useMantineColorScheme } from "@mantine/core";

import type { FC } from "react";

type SettingRowSelectProps = {
  label: string;
  children: React.ReactNode;
} & React.ComponentPropsWithoutRef<"div">;

export const SettingRowSelect: FC<SettingRowSelectProps> = ({ label, children, ...props }) => {
  const { colorScheme } = useMantineColorScheme({ keepTransitions: true });
  const isDark = colorScheme === "dark";
  const textColor = isDark ? "primaryDark.4" : "secondary.6";

  return (
    <Flex py="md" justify="space-between" align="center" {...props}>
      <Box w={100}>
        <Text size="md" c={textColor}>
          {label}
        </Text>
      </Box>

      <Flex align="center" gap="md">
        {children}
      </Flex>
    </Flex>
  );
};
